import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {UnitBankAccountReqRes} from 'src/app/shared/models/gp/UnitBankAccountReqRes.model';

@Component({
  selector: 'terra-unit-bank-account-document',
  templateUrl: './unit-bank-account-document.component.html',
  styleUrls: ['./unit-bank-account-document.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitBankAccountDocumentComponent implements OnInit {
  @Input() bankAccount: UnitBankAccountReqRes;

  constructor() {
  }

  ngOnInit(): void {
  }
}
